export enum MainRoutes {
    ASSIGNMENT = 'assignment',
    ASSIGNMENT_CHANGE = 'assignment/operate',
    ASSIGNMENT_SIGN = 'assignment/sign',
    CONTRIBUTION = 'contribution',
    CONTRIBUTION_SIGN = 'contribution/sign',
    CONTRIBUTION_TRANSFER = 'contribution/operate',
    DICTIONARY = 'dictionary',
    DISINVESTMENT = 'disinvestment',
    DISINVESTMENT_OPERATE = 'disinvestment/operate',
    DISINVESTMENT_SIGN = 'disinvestment/sign',
    FULL_DATA = 'onboarding/full-data',
    FULL_DATA_ACCOUNT = 'onboarding/full-data/account',
    FULL_DATA_LIST = 'onboarding/full-data/list',
    FULL_DATA_PROFILE = 'onboarding/full-data/list/:id',
    MEETING_SIGN = 'operative/meeting-sign',
    NEW_CONTRACT = 'onboarding/new',
    NEW_CONTRACT_INTRO = 'onboarding/new/intro',
    NEW_CONTRACT_NATURE = 'onboarding/new/nature',
    NEW_CONTRACT_NATURAL = 'onboarding/new/natural',
    NEW_CONTRACT_MINOR_DISABLED = 'onboarding/new/minor-disabled',
    NEW_CONTRACT_FORM = 'onboarding/new/form',
    NEW_CONTRACT_PARTICIPANTS = 'onboarding/new/participants',
    NEW_CONTRACT_SIGN = 'onboarding/new/sign',
    NEW_CONTRACT_ADVICE = 'onboarding/new/advice',
    NOT_FOUND = 'error/not-found',
    OPERATIVE = 'operative',
    OPERATIVE_LIST = 'operative/list',
    OPERATIVE_MY_PRODUCTS = 'operative/products/my-list',
    OPERATIVE_OPERATE = 'operative/operate',
    OPERATIVE_PRODUCTS = 'operative/products/list',
    OPERATIVE_PRODUCTS_DETAIL = 'operative/products/:id',
    OPERATIVE_SIGN = 'operative/sign',
    PHONE = 'phone',
    REPEAT_TEST = 'repeat/test',
    REPEAT_TEST_QUESTION = 'repeat/test/:question',
    REPEAT_TEST_RESULT = 'repeat/test/result',
    REPEAT_TEST_RESULT_SUITABILITY = 'repeat/test/result-suitability',
    REPEAT_TEST_SIGN = 'repeat/test/sign',
    REPEAT_TEST_SIGN_HANDWRITING = 'repeat/test/sign/handwritten',
    TEST = 'onboarding/test',
    TEST_QUESTION = 'onboarding/test/:question',
    TEST_RATE = 'onboarding/test/rate',
    TEST_RESULT = 'onboarding/test/result',
    TEST_RESULT_SUITABILITY = 'onboarding/test/result-suitability',
    TEST_TRANSFER = 'onboarding/test/transfer',
    UNAUTHORIZED = 'error/unauthorized',
    VIEW_ACCOUNT = 'view/account',
    VIEW_PROFILE = 'view/profile/:id',
}
